import * as ng from 'angular';
import { StSelectRow } from './st-select-row.directive';

export const StSelectRowModule: string =
    ng.module('st-select-row', [
    ])
        .directive('stSelectRow', StSelectRow)
        .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/third/smart-table/st-select-row/st-select-row.module.ts